<div class="container" id="mainContent">
  <div class="modal-header bg-theme bg-theme-txt">
    <h5 class="modal-title" id="modal-basic-title">My Article 1/6th Report</h5>
  </div>

  <div class="modal-body">
    <div class="row mt-2">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-4">
            <label
              >ICAIRegistration Date <span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-sm-6">
            <div class="input-group">
              <input
                class="form-control form-control-xs"
                [(ngModel)]="ICAIRegDate"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-4">
            <label>To Date<span class="text-danger">*</span> </label>
          </div>

          <div class="col-sm-6">
            <div class="input-group">
              <input
                class="form-control form-control-xs"
                placeholder="dd/mm/yyyy"
                name="fromDate"
                ngbDatepicker
                #fromDate="ngbDatepicker"
                [placement]="'bottom'"
                [(ngModel)]="selectedDate"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-theme calendar"
                  (click)="fromDate.toggle()"
                  type="button"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-sm-2">
        <button
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onViewReport()"
        >
          View Report
        </button>
      </div>
    </div>
  </div>

  <app-article-one-sixth-report
    [isMyReport]="true"
    [reportList]="reportList"
    [showReportDetail]="showReportDetail"
  ></app-article-one-sixth-report>
</div>
